import {useEffect} from 'react';

/**
 * Custom hook to observe size changes of a given DOM element using ResizeObserver.
 *
 * @param {function} callback - Function to be called when the element resizes.
 * @param {HTMLElement | null} element - The DOM element to observe.
 */
export const useResizeObserver = (element: HTMLElement | null, callback: () => void) => {
    useEffect(() => {
        if (element) {
            // Create a ResizeObserver to watch the sidebar element
            const resizeObserver = new ResizeObserver(() => {
                callback();
            });

            if (element) {
                resizeObserver.observe(element);
            }

            // Cleanup
            return () => {
                resizeObserver.disconnect();
            };
        }
        return () => {};
    }, [element, callback]);
};
